import App from './App';
import { createRoot } from 'react-dom/client';

const domNode = document.getElementById('app_body');
const root = createRoot(domNode);

root.render(<App />);
